
import { useSelector  } from 'react-redux';

import { getReportProjectId } from '../reducers/project';

export default function useReportProjectId() {
    const projectId = useSelector(state => getReportProjectId(state.project));
    return projectId;
}
